module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "agit-map-container"
  }, [_c('div', {
    staticClass: "agit-map-wrapper"
  }, [_c('div', {
    staticClass: "agit-map"
  }, [_c('img', {
    staticClass: "agit-map__img",
    attrs: {
      "src": "/images/homepage/agit-map.png",
      "alt": "서울 전역 지도"
    }
  }), _vm._v(" "), _vm._l((_vm.buttons), function(button) {
    return _c('button', {
      class: ("agit-point agit-point--" + (_vm.guMatch[button.addrGu])),
      on: {
        "click": function($event) {
          return _vm.changeList(button.addrGu)
        }
      }
    }, [_c('label', {
      staticClass: "agit-point__label"
    }, [_vm._v(_vm._s(button.addrGu))]), _vm._v(_vm._s(button.guCount)), _c('p', {
      staticClass: "alt-text"
    }, [_vm._v(_vm._s(button.addrGu) + " " + _vm._s(button.guCount) + " 개소")])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "agit-list-wrapper"
  }, [_c('p', {
    staticClass: "agit-list-helper"
  }, [_vm._v("* 원하시는 자치구를 클릭하시면 해당하는 협력기관을 확인하실 수 있습니다.")]), _vm._v(" "), _c('h4', {
    staticClass: "agit-box__text agit-box__text--location",
    attrs: {
      "id": "titleGu"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "agit-boxs"
  }, _vm._l((_vm.agites), function(agit) {
    return _c('li', {
      staticClass: "agit-box clearfix"
    }, [_c('div', {
      staticClass: "agit-box__text agit-box__text--location"
    }, [_vm._v(_vm._s(agit.name))]), _vm._v(" "), _c('div', {
      staticClass: "agit-box__text agit-box__text--gu"
    }, [_vm._v(_vm._s(agit.addrGu))]), _vm._v(" "), _c('div', {
      staticClass: "agit-box__text agit-box__text--address"
    }, [_vm._v(_vm._s(agit.addr1) + " " + _vm._s(agit.addr2))]), _vm._v(" "), _c('a', {
      staticClass: "agit-box__text agit-box__text--link",
      attrs: {
        "href": agit.url,
        "target": "_blank",
        "rel": "noopener noreferrer",
        "title": "새창열림"
      }
    }, [_vm._v(_vm._s(agit.url))])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c655fb6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/portal/PortalAgit.vue
// module id = 1310
// module chunks = 6